import { useAppSelector } from "../../../../../store";
import { IncomeBreakdown } from "../../IncomeBreakdown/IncomeBreakdown";
import { CurrentEstimatedIncomeCard } from "../../IncomeBreakdown/Components/CurrentEstimatedIncomeCard/CurrentEstimatedIncomeCard";
import { FetchAnnualIncomeBreakdownData } from "./AnnualIncomeBreakdownDataLayer";
import { useIncomeBreakdownTiles } from "../../IncomeBreakdown/useIncomeBreakdownTiles";
import { ErrorTile } from "../../../../../common/components/ErrorTile/ErrorTile";
import { IncomeBreakdownLoader } from "../../IncomeBreakdown/IncomeBreakdownLoader/IncomeBreakdownLoader";
import { maskAnnualIncomeTiles } from "./AnnualIncomeBreakdown.mask";

import defaultContent from "../../../../../content/performanceIncomeDashboard";
import { useTranslation } from "react-i18next";

export const AnnualIncomeBreakdown = () => {
  const { t } = useTranslation(["performanceIncomeDashboard"]);
  const { selectedPeriod } = useAppSelector((state) => state.period);
  const { menuConfig } = useAppSelector((state) => state.boot.shellConfig);
  const { isLoading, errorStatus, refetch, annualIncomeBreakdownData } = FetchAnnualIncomeBreakdownData(selectedPeriod);

  const showData = useAppSelector((state) => state.showData.showData);

  const { incentiveTiles, estimatedIncomeValue, hasAnnualCorePlanBonuses } = useIncomeBreakdownTiles(
    annualIncomeBreakdownData,
    menuConfig,
  );

  if (isLoading) {
    return (
      <div data-testid="income-breakdown-section">
        <IncomeBreakdownLoader isLoading={isLoading} annual />
      </div>
    );
  }

  if (errorStatus) {
    return (
      <div data-testid="income-breakdown-section">
        <ErrorTile
          clickFunction={refetch}
          errorStatus={errorStatus}
          isLoading={isLoading}
          tealiumTrackId="Annual_Income_Breakdown"
        />
      </div>
    );
  }

  const tiles = maskAnnualIncomeTiles(incentiveTiles, showData) ?? [];
  const maskedEstimatedIncome = showData ? estimatedIncomeValue : "--";

  const estimatedIncomeCard = <CurrentEstimatedIncomeCard value={maskedEstimatedIncome} annual={true} />;

  return (
    <div data-testid="income-breakdown-section">
      <IncomeBreakdown estimatedIncomeCard={estimatedIncomeCard} tiles={tiles} />
      {hasAnnualCorePlanBonuses && (
        <p className="AnnualPerformanceIncome__coreplanDisclaimer">
          {t("corePlanBonusesDisclaimer", defaultContent.corePlanBonusesDisclaimer as string)}
        </p>
      )}
    </div>
  );
};
